import {ListFilterCheckboxSection} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {TEAM_STATUS_FILTER_OPTIONS} from '../../config/team-filter.config';

import type {FirmUserRoleStatus} from '@sollapay/enums';
import type {FC} from 'react';

export interface TeamFilterStatusSectionProps {
  statuses: FirmUserRoleStatus[];
  onChange: (statuses: FirmUserRoleStatus[]) => void;
}

export const TeamFilterStatusSection: FC<TeamFilterStatusSectionProps> = ({statuses, onChange}) => {
  const {t} = useTranslation('team');

  const options = TEAM_STATUS_FILTER_OPTIONS.map(opt => ({
    value: opt.value,
    label: t(opt.i18nKey)
  }));

  return (
    <ListFilterCheckboxSection
      title={t('filter.sections.status')}
      options={options}
      selected={statuses}
      onChange={vals => onChange(vals as FirmUserRoleStatus[])}
    />
  );
};
